import React, { useState } from "react";
import { Table, Form } from "react-bootstrap";
import { InfoIconCard } from "pages/login/NotFound";
import { _t } from "app/i18n/i18n";
import "./disclosures.css";

export const SecurityTable = ({ securities = [], onSelectSecurity }) => {
  return (
    <>
      <section className="security-table position-relative overflow-auto">
        <Table responsive hover variant="sm text-wrap text-sm small">
          <thead className="thead-grey">
            <tr>
              <th>{_t("Company Name")}</th>
              <th>Bloomberg</th>
              <th>RIC</th>
              <th>SEDOL</th>
              <th>CUSIP</th>
              <th>{_t("Selected")}</th>
            </tr>
          </thead>
          <tbody>
            {securities.map((row, index) => (
              <TableRow key={index} onSelectSecurity={onSelectSecurity} row={row} />
            ))}
          </tbody>
        </Table>
      </section>
      {securities.length === 0 && <NotFound />}
    </>
  );
};

const TableRow = ({ onSelectSecurity, row }) => {
  const [checked, setChecked] = useState(false);
  const onClick = (row, checked) => {
    onSelectSecurity(row, !checked);
    setChecked(!checked);
  };
  return (
    <tr onClick={() => onClick(row, checked)} className={checked ? "bg-light" : ""}>
      <td>{row.securityName}</td>
      <td>{row.bloomberg}</td>
      <td>{row.ric}</td>
      <td>{row.sedol7}</td>
      <td>{row.cusip}</td>
      <td>
        <Form.Check onChange={() => onClick(row, checked)} checked={checked}></Form.Check>
      </td>
    </tr>
  );
};

const NotFound = () => (
  <InfoIconCard
    className="mx-auto shadow-none"
    title={_t("No results found.")}
    icon="fa fa-search fa-3x mb-3"
    body={
      <article>
        {_t("No results found.")}
        <br />
        {_t("Please broaden your search criteria.")}
      </article>
    }
  />
);
